import { DELIMITATION_DESCRIPTORS } from "inova-front-core/constants";

export class InovaMapHeper{
    static isPointInsidePolygon(position:any, poligon:any):boolean{
        return true;
    }

    static getPositionByPoint(point:string) {
        if (point && point.indexOf("POINT(") != -1) {
          let result = point.replace("POINT(", "").replace(")", "");
          let lgnLatString = result.split(" ");
          let lng = parseFloat(lgnLatString[0]);
          let lat = parseFloat(lgnLatString[1]);
          const position:any = { lng, lat };
          if (lgnLatString.length == 3) {
            position.date = lgnLatString[2];
          }
          return position;
        }
        return null;
      }
  
      static getPositionByPointWithDescriptors(point:any, descriptors=DELIMITATION_DESCRIPTORS):any {
        if (point && point.indexOf("POINT(") != -1) {
          let result = point.replace("POINT(", "").replace(")", "");
          let lgnLatString = result.split(" ");
          let position:any={};
          position[descriptors[0]]=parseFloat(lgnLatString[0]);
          position[descriptors[1]]=parseFloat(lgnLatString[1]);
          if(lgnLatString.length>2){
            for(let i=2; i<lgnLatString.length; i++){
              if(i<descriptors.length){
                position[descriptors[i]]=lgnLatString[i];
              }
            }
          }
          else{
            position[descriptors[2]]=0;
          }
          return position;
        }
        return null;
      }
}